import React from 'react';
import {Container as Con} from 'react-bootstrap';

const Container: React.FC<any> = (props) => {
    return(
        <Con fluid style={{ maxWidth : "100vw" }} id="page-wrapper" className="p-0 m-0">
            {props.children}
        </Con>
    )
}

export default Container;;